import { Period } from '../context/PeriodProvider';
import { fetchAndParse } from '../lib/utils';
import { ClientConfig } from '../types/ClientConfig';
import { Role } from '../types/Role';
import { Savings } from '../types/Savings';
import { BaseClient, Endpoints, getHeaders } from './BaseClient';

export const SavingsClient = (config: ClientConfig) => {
    const { accessToken, userRole, param = '' } = config;
    const headers = getHeaders(accessToken);
    const baseClientConfig = {
        useAdminRoute: userRole === Role.ADMIN && param !== '',
    };

    const getSavings = (period: Period): Promise<Savings> => {
        const apiUrl = `${BaseClient(baseClientConfig).getApiUrl(Endpoints.SAVINGS)}/${param}?quarter=${period.quarter}&year=${period.year}`;

        return fetchAndParse<Savings>(apiUrl, {
            headers,
        });
    };

    return {
        getSavings,
    };
};
